(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-before-after"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ss-bna .ba-wrap').forEach(function (wrap) {
      var handle = wrap.querySelector('.ba-handle');
      // Note: ba-lbl-a always tracks the region LEFT of the handle, ba-lbl-b
      // always tracks the region RIGHT of the handle. Which Before/After
      // text lives in each is decided server-side (image_arrangement), but
      // the region math below is purely positional and doesn't need to care.
      var lblLeftRegion = wrap.querySelector('.ba-lbl-a');
      var lblRightRegion = wrap.querySelector('.ba-lbl-b');
      var edge = parseFloat(wrap.dataset.edge);
      if (isNaN(edge)) edge = 12; // % of width below which a side's label auto-hides

      var showLabels = function () { wrap.classList.add('is-dragging'); };
      var hideLabels = function () { wrap.classList.remove('is-dragging'); };

      wrap.addEventListener('mousedown', showLabels);
      wrap.addEventListener('touchstart', showLabels, { passive: true });

      // Release can happen anywhere on the page, not just over the wrap.
      document.addEventListener('mouseup', hideLabels);
      document.addEventListener('touchend', hideLabels);
      document.addEventListener('touchcancel', hideLabels);

      // Keep the badges glued to the handle and hide whichever side's image
      // is essentially gone from view (e.g. dragged almost fully to one side).
      var applyPosition = function (pct) {
        if (isNaN(pct)) return;
        pct = Math.max(0, Math.min(100, pct));

        wrap.style.setProperty('--ba-pos', pct + '%');

        // Region left of the handle is the clipped (.ba-after) image; region
        // right of the handle is the unclipped (.ba-before) image underneath.
        var leftWidth = pct;
        var rightWidth = 100 - pct;

        lblLeftRegion.classList.toggle('is-visible', leftWidth > edge);
        lblRightRegion.classList.toggle('is-visible', rightWidth > edge);
      };

      // Read the handle's current position (set either by stone-stories.js
      // during drag, or by this section's own inline style on load).
      var readPct = function () {
        return parseFloat(handle.style.left);
      };

      applyPosition(readPct());

      // Single source of truth: poll the real handle position every frame
      // while dragging, via requestAnimationFrame. This tracks whatever
      // stone-stories.js is doing (however it moves the handle) without a
      // second, independent pointer calculation fighting it — that's what
      // was causing the jittery/"stuck" feeling during drag.
      var rafId = null;
      var tick = function () {
        applyPosition(readPct());
        if (wrap.classList.contains('is-dragging')) {
          rafId = requestAnimationFrame(tick);
        } else {
          rafId = null;
          applyPosition(readPct()); // settle on the final position
        }
      };
      var startTracking = function () {
        if (rafId === null) rafId = requestAnimationFrame(tick);
      };

      wrap.addEventListener('mousedown', startTracking);
      wrap.addEventListener('touchstart', startTracking, { passive: true });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-header"]) return;
  try {
    
  // Dropdown (desktop) + accordion (mobile) behaviour for header submenus.
  // Guarded so this never double-initialises if similar header/scroll JS
  // already exists elsewhere in the theme (e.g. assets/theme.js).
  (function () {
    if (window.__ssHeaderNavInit) return;
    window.__ssHeaderNavInit = true;

    document.addEventListener('DOMContentLoaded', function () {
      // ── Desktop dropdown: keep aria-expanded in sync for keyboard/SR users.
      // CSS handles the actual show/hide via :hover / :focus-within, this
      // just keeps ARIA state correct and lets Escape close an open panel.
      var drops = document.querySelectorAll('.hdr-drop');
      drops.forEach(function (drop) {
        var trigger = drop.querySelector('.hdr-drop-trigger');
        var panel = drop.querySelector('.hdr-drop-panel');
        if (!trigger || !panel) return;

        function open() { trigger.setAttribute('aria-expanded', 'true'); }
        function close() { trigger.setAttribute('aria-expanded', 'false'); }

        drop.addEventListener('mouseenter', open);
        drop.addEventListener('mouseleave', close);
        trigger.addEventListener('focus', open);
        drop.addEventListener('focusout', function (e) {
          if (!drop.contains(e.relatedTarget)) close();
        });
        drop.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            close();
            trigger.blur();
          }
        });
      });

      // ── Mobile accordion submenus.
      var toggles = document.querySelectorAll('.mob-nav-toggle');
      toggles.forEach(function (btn) {
        var item = btn.closest('.mob-nav-item');
        var sub = item ? item.querySelector('.mob-nav-sub') : null;
        if (!sub) return;

        btn.addEventListener('click', function () {
          var isOpen = btn.getAttribute('aria-expanded') === 'true';

          // Close any other open submenu (single-open accordion). Remove
          // this loop if you want multiple sections open at once.
          toggles.forEach(function (otherBtn) {
            if (otherBtn === btn) return;
            var otherItem = otherBtn.closest('.mob-nav-item');
            var otherSub = otherItem ? otherItem.querySelector('.mob-nav-sub') : null;
            otherBtn.setAttribute('aria-expanded', 'false');
            if (otherSub) {
              otherSub.classList.remove('open');
              otherSub.style.maxHeight = null;
            }
          });

          if (isOpen) {
            btn.setAttribute('aria-expanded', 'false');
            sub.classList.remove('open');
            sub.style.maxHeight = null;
          } else {
            btn.setAttribute('aria-expanded', 'true');
            sub.classList.add('open');
            sub.style.maxHeight = sub.scrollHeight + 'px';
          }
        });
      });

      // When the drawer closes (via #mob-close or #mob-overlay, wired up
      // elsewhere), collapse any open accordion sections so it reopens fresh.
      var mobNav = document.getElementById('mob-nav');
      if (mobNav) {
        var mobObserver = new MutationObserver(function () {
          if (!mobNav.classList.contains('open')) {
            toggles.forEach(function (btn) {
              var item = btn.closest('.mob-nav-item');
              var sub = item ? item.querySelector('.mob-nav-sub') : null;
              btn.setAttribute('aria-expanded', 'false');
              if (sub) {
                sub.classList.remove('open');
                sub.style.maxHeight = null;
              }
            });
          }
        });
        mobObserver.observe(mobNav, { attributes: true, attributeFilter: ['class'] });
      }

      // ── Scroll progress bar width. If you already update #ss-progress
      // elsewhere, this early-returns via the guard at the top of the file
      // so it won't run twice — but it's safe/idempotent either way.
      var bar = document.getElementById('ss-progress');
      if (bar) {
        var ticking = false;
        function updateBar() {
          var scrollTop = window.scrollY || document.documentElement.scrollTop;
          var docHeight = document.documentElement.scrollHeight - window.innerHeight;
          var pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
          bar.style.width = pct + '%';
          ticking = false;
        }
        window.addEventListener('scroll', function () {
          if (!ticking) {
            window.requestAnimationFrame(updateBar);
            ticking = true;
          }
        }, { passive: true });
        updateBar();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('#hero');
    if (!section) return;
    
    const slides = section.querySelectorAll('.hero-slide');
    const dots = section.querySelectorAll('.hero-dot');
    const prevBtn = section.querySelector('.hero-prev');
    const nextBtn = section.querySelector('.hero-next');
    const autoplay = section.dataset.sliderAutoplay === 'true';
    const speed = parseInt(section.dataset.sliderSpeed) || 5000;
    
    let currentIndex = 0;
    let totalSlides = slides.length;
    let autoplayTimer = null;
    let isTransitioning = false;
    
    if (totalSlides <= 1) return;
    
    // Initialize first slide
    slides.forEach((slide, index) => {
      if (index === 0) {
        slide.classList.add('active');
      } else {
        slide.classList.remove('active');
      }
    });
    
    function goToSlide(index) {
      if (isTransitioning || index === currentIndex) return;
      isTransitioning = true;
      
      // Remove active from all slides
      slides.forEach((slide) => {
        slide.classList.remove('active');
        slide.classList.remove('prev');
        slide.classList.remove('next');
      });
      
      // Set direction classes for animation
      if (index > currentIndex || (index === 0 && currentIndex === totalSlides - 1)) {
        // Going forward
        slides[currentIndex].classList.add('prev');
        slides[index].classList.add('next');
      } else {
        // Going backward
        slides[currentIndex].classList.add('next');
        slides[index].classList.add('prev');
      }
      
      // Small delay to trigger animation
      setTimeout(() => {
        slides[index].classList.add('active');
        slides[index].classList.remove('prev', 'next');
        
        // Update dots
        dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === index);
        });
        
        currentIndex = index;
        
        // Reset autoplay
        resetAutoplay();
        
        setTimeout(() => {
          isTransitioning = false;
        }, 200);
      }, 50);
    }
    
    function nextSlide() {
      const next = (currentIndex + 1) % totalSlides;
      goToSlide(next);
    }
    
    function prevSlide() {
      const prev = (currentIndex - 1 + totalSlides) % totalSlides;
      goToSlide(prev);
    }
    
    function resetAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
      if (autoplay) {
        autoplayTimer = setInterval(nextSlide, speed);
      }
    }
    
    // Event Listeners
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    if (nextBtn) nextBtn.addEventListener('click', nextSlide);
    
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        goToSlide(index);
      });
    });
    
    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') prevSlide();
      if (e.key === 'ArrowRight') nextSlide();
    });
    
    // Pause on hover
    section.addEventListener('mouseenter', function() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    });
    
    section.addEventListener('mouseleave', function() {
      resetAutoplay();
    });
    
    // Touch support
    let touchStartX = 0;
    let touchEndX = 0;
    
    section.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    });
    
    section.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    });
    
    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;
      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    }
    
    // Start autoplay
    resetAutoplay();
  });

  } catch(e) { console.error(e); }
})();
})();
